import React from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { type LoadingProps } from '../../types';
import { Container, Inner, Side, SkeletonItemContainer } from '../styled';

const RotationLoading = ({ size, numberOfDays, variant }: LoadingProps): JSX.Element => {
	const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;

	return (
		<Container highlighted={false} size={size}>
			{variant === 'full' && (
				<Side>
					<Skeleton height={2} width={7} />
				</Side>
			)}
			<Inner>
				{Array.from({ length: sectionCount }).map((_, i) => {
					return (
						<SkeletonItemContainer numberOfDays={sectionCount} key={i}>
							<Skeleton height={2.375} width={2.375} />
						</SkeletonItemContainer>
					);
				})}
			</Inner>
		</Container>
	);
};

export { RotationLoading };
